import React, { useState } from 'react';
import { Plus, Pencil, Trash2, Check, X } from 'lucide-react';
import { toast } from 'sonner';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';
import { loadPaymentMethods } from './PaymentControl';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const BASE = `${API_URL}/api/admin/bancos/medios`;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('admin_token')}`, 'Content-Type': 'application/json' });

const call = async (url, method, body) => {
  const res = await fetch(url, { method, headers: auth(), body: body ? JSON.stringify(body) : undefined });
  const j = await res.json().catch(() => ({}));
  if (!res.ok) { toast.error(j.detail || 'No se pudo guardar'); return false; }
  loadPaymentMethods(true);
  return true;
};

const MethodRow = ({ m, onChange }) => {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(m.name);
  const save = async () => { if (await call(`${BASE}/${m.id}`, 'PUT', { name })) { setEditing(false); onChange(); } };
  const remove = async () => {
    if (window.confirm(`¿Eliminar "${m.name}"?`) && await call(`${BASE}/${m.id}`, 'DELETE')) onChange();
  };
  return (
    <div className="flex items-center gap-2 py-2" data-testid={`method-row-${m.id}`}>
      {editing ? (
        <>
          <Input value={name} onChange={e => setName(e.target.value)} className="h-8" data-testid={`method-name-input-${m.id}`} />
          <button onClick={save} className="p-1.5 text-green-600" data-testid={`method-save-${m.id}`}><Check size={16} /></button>
          <button onClick={() => { setEditing(false); setName(m.name); }} className="p-1.5 text-gray-400"><X size={16} /></button>
        </>
      ) : (
        <>
          <span className="flex-1 text-sm text-gray-800">{m.name}</span>
          <button onClick={() => setEditing(true)} className="p-1.5 text-gray-400 hover:text-blue-600" title="Renombrar" data-testid={`method-edit-${m.id}`}><Pencil size={14} /></button>
          <button onClick={remove} className="p-1.5 text-gray-400 hover:text-red-600" title="Eliminar" data-testid={`method-delete-${m.id}`}><Trash2 size={14} /></button>
        </>
      )}
    </div>
  );
};

export const MethodsManager = ({ methods, onChange }) => {
  const [name, setName] = useState('');
  const add = async () => { if (await call(BASE, 'POST', { name })) { setName(''); onChange(); } };
  return (
    <details className="bg-white rounded-xl border shadow-sm p-4" data-testid="methods-manager">
      <summary className="cursor-pointer text-sm font-semibold text-gray-900">Gestionar medios de pago</summary>
      <div className="divide-y mt-2">{methods.map(m => <MethodRow key={m.id} m={m} onChange={onChange} />)}</div>
      <div className="flex gap-2 mt-3">
        <Input placeholder="Nuevo medio de pago (p. ej. BBVA)" value={name} onChange={e => setName(e.target.value)} className="h-9" data-testid="method-new-name" />
        <Button onClick={add} disabled={!name.trim()} size="sm" data-testid="method-add-btn"><Plus size={14} className="mr-1" />Añadir</Button>
      </div>
    </details>
  );
};
